import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Typography } from '@material-ui/core'
import { read } from 'actions/data'
import Button from 'components/theme/Button'
// import Select from 'components/theme/Select'
import { selectUserToAdd, updateAssignmentPoolUsers } from 'actions/roundRobin'
import Sortable from 'components/theme/Sortable'
import ItemUI from './ItemUI'
const update = require('immutability-helper')

// const styles = (theme) => ({})

class AssignmentPool extends Component {
  state = { data: [] }

  componentDidMount() {
    if (this.props.assignmentPoolSelected) {
      this.props
        .read(this.props.assignmentPoolSelected, 'account/ap')
        .then(payload => {
          this.setState({ data: payload?.pool?.users })
        })
    }
  }

  setAsyncState = newState =>
    new Promise(resolve => this.setState(newState, resolve))

  onDragOver = (dragIndex, hoverIndex) => {
    const { data } = this.state
    const dragObj = data[dragIndex]

    this.setAsyncState({
      data: update(data, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragObj],
        ],
      }),
    }).then(() =>
      this.props.updateAssignmentPoolUsers({
        id: this.props.assignmentPoolSelected,
        users: this.state.data,
      }),
    )
  }

  handleSelectSubmit = () => {
    return this.setAsyncState({
      data: [
        ...this.state.data,
        ...this.props.selectValue.map(el => ({ username: el.value })),
      ],
    })
      .then(() =>
        this.props.updateAssignmentPoolUsers({
          id: this.props.assignmentPoolSelected,
          users: this.state.data,
        }),
      )
      .then(() =>
        this.props.read(this.props.assignmentPoolSelected, 'account/ap'),
      )
      .then(payload => {
        this.setState({ data: [] })
        return payload
      })
      .then(payload => this.setState({ data: payload?.pool?.users }))
  }

  render() {
    const ItemUIComponent = props => (
      <ItemUI
        {...props}
        assignmentPoolSelected={this.props.assignmentPoolSelected}
      />
    )

    return (
      <div style={{ textAlign: 'left' }}>
        <Button
          variant="contained"
          onClick={this.props.goBack}
          color="secondary"
        >
          Back
        </Button>
        <div style={{ marginTop: 15 }}>
          <Typography variant="h5" gutterBottom>
            Who should we add to the assignment pool,{' '}
            <b>{this.props.assignmentPoolName}</b>?
          </Typography>
          <div style={{ position: 'relative' }}>
            {this.props.users?.map?.(user => {
              return (
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginRight: 5 }}
                  onClick={() => {
                    this.props
                      .updateAssignmentPoolUsers({
                        id: this.props.assignmentPoolSelected,
                        users: [
                          ...this.state.data,
                          { username: user?.user_name },
                        ],
                      })
                      .then(() =>
                        this.props.read(
                          this.props.assignmentPoolSelected,
                          'account/ap',
                        ),
                      )
                      .then(payload => {
                        this.setState({ data: [] })
                        return payload
                      })
                      .then(payload =>
                        this.setState({ data: payload?.pool?.users }),
                      )
                  }}
                >
                  {user?.first_name} {user?.last_name}
                </Button>
              )
            })}
          </div>
          {this.props.lastAssignedUser && (
            <div style={{ marginTop: 15, marginBottom: 15 }}>
              <div>
                Last assigned user:{' '}
                <strong>
                  {this.props.lastAssignedUser
                    ? this.props.lastAssignedUser.first_name
                    : ''}{' '}
                  {this.props.lastAssignedUser
                    ? this.props.lastAssignedUser.last_name
                    : ''}
                </strong>
              </div>
            </div>
          )}
          <div style={{ marginTop: 15, marginBottom: 15 }}>
            <div>You can sort by dragging the users below.</div>
          </div>
          <Sortable
            data={this.state.data}
            itemUI={ItemUIComponent}
            onDragOver={this.onDragOver}
            onDelete={index => {
              this.setAsyncState({
                data: this.state.data?.filter?.((el, idx) => idx !== index),
              }).then(() =>
                this.props.updateAssignmentPoolUsers({
                  id: this.props.assignmentPoolSelected,
                  users: this.state.data,
                }),
              )
            }}
          />
        </div>
      </div>
    )
  }
}

export default connect(
  (state, { assignmentPoolSelected }) => ({
    users: Object.values(state.data['account/user'] || {}),
    selectValue: state.roundRobin.usersToAddSelectValue,
    usersInAssignmentPool:
      state.data?.['account/ap']?.[assignmentPoolSelected]?.pool?.users,
    assignmentPoolName:
      state.data?.['account/ap']?.[assignmentPoolSelected]?.name,
    lastAssignedUser:
      state.data?.['account/user']?.[
        state.data?.['account/ap']?.[assignmentPoolSelected]?.pool
          ?.lastassigneduser?.username
      ],
  }),
  dispatch =>
    bindActionCreators(
      { selectUserToAdd, updateAssignmentPoolUsers, read },
      dispatch,
    ),
)(AssignmentPool)
